import { Box } from '@mui/material';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFragmentTagGroups } from '../../../hooks/useFragmentTagGroups';
import { useFragmentForm } from '../useFragmentForm';

export function FragmentTagGroupsSelector() {
  const { watch, setValue } = useFragmentForm();
  const stationId = watch('stationId');
  const tags = watch('tags') || '';
  const tagGroups = useFragmentTagGroups(stationId);

  // Set default tags on mount if a default group exists and tags are empty
  useEffect(() => {
    if (!tagGroups.length) {
      return;
    }

    // Only set defaults if tags field is empty or undefined
    const hasTags = tags && tags.trim().length > 0;
    if (hasTags) {
      return;
    }

    const defaultGroup = tagGroups.find((group) => group.default);
    if (defaultGroup && defaultGroup.tags.length > 0) {
      setValue('tags', defaultGroup.tags.join(', '));
    }
  }, []);

  if (!tagGroups.length) {
    return null;
  }

  function handleGroupClick(group: { name: string; tags: string[] }) {
    setValue('tags', group.tags.join(', '));
  }

  return (
    <Box display={'flex'}>
      <FormattedMessage id="fragments.form.useTags" defaultMessage="Usar tags:" />
      <Box display={'flex'} gap={1} ml={1}>
        {tagGroups.map((group, index) => (
          <Box key={group.name}>
            <a
              href={'#'}
              onClick={(event) => {
                event.preventDefault();
                handleGroupClick(group);
              }}
            >
              {group.name}
            </a>
            {index !== tagGroups.length - 1 && <>&nbsp;&nbsp;/</>}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
